
import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleWhatsAppClick = () => {
    const phoneNumber = '+971585375437';
    const message = encodeURIComponent('Hallo NextStep, ich interessiere mich für die Auswanderungsberatung in die V.A.E. und bitte um weitere Informationen. Mein Name ist: [Name]');
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/872a27432b8adaad402c2abfed07012d/f6440142cf3924a76ade8e6e073ea665.jpeg" 
              alt="NextStep - Where Ambitions Become Companies" 
              className="h-12 w-auto"
            />
          </div>

          {/* CTA Button */}
          <div className="hidden md:block">
            <button
              onClick={handleWhatsAppClick}
              className="bg-red-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              WhatsApp Chat
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 cursor-pointer"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4 pt-4">
              <a href="#services" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">
                Services
              </a>
              <a href="#process" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">
                Prozess
              </a>
              <a href="#success-stories" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">
                Erfolgsgeschichten
              </a>
              <a href="#about" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">
                Über uns
              </a>
              <a href="#faq" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">
                FAQ
              </a>
              <button
                onClick={handleWhatsAppClick}
                className="bg-red-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer w-full text-center"
              >
                <i className="ri-whatsapp-line mr-2"></i>
                WhatsApp Chat
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}